import { TUserRole } from '@/constants/roles';

// Mirrors the backend content-creator DTOs/enums
// (see back-end/backend-monolith/src/content-creator).

export const CREATOR_APPLICATION_STATUSES = ['pending', 'approved', 'rejected'] as const;
export type TCreatorApplicationStatus = (typeof CREATOR_APPLICATION_STATUSES)[number];

export const CREATOR_APPLICANT_TYPES = ['existing_user', 'external_email'] as const;
export type TCreatorApplicantType = (typeof CREATOR_APPLICANT_TYPES)[number];

export const CREATOR_APPLICATION_PAGE_SIZE_OPTIONS = [20, 50, 100] as const;
export type TCreatorApplicationPageSize = (typeof CREATOR_APPLICATION_PAGE_SIZE_OPTIONS)[number];

export type TCreatorApplicantName = {
  firstName: string;
  lastName: string;
};

export type TCreatorApplicationLocation = {
  city?: string;
  state?: string;
  zip?: string;
};

export type TCreatorApplicationProfile = {
  photoUrl?: string;
  bio?: string;
  location?: TCreatorApplicationLocation;
  certifications?: string[];
  contentFocus?: string[];
  socialLinks?: {
    platform: string;
    url: string;
  }[];
};

// Item shape returned by GET /admin/content-creator-applications (list).
export type TCreatorApplicationListItem = {
  _id: string;
  applicantType: TCreatorApplicantType;
  applicantName: TCreatorApplicantName;
  applicantEmail: string;
  existingRoles: TUserRole[];
  hasOrganization: boolean;
  submittedAt?: string | null;
  status: TCreatorApplicationStatus;
};

// Prior applications surfaced alongside the detail view.
export type TCreatorApplicationSummary = {
  _id: string;
  applicantName?: TCreatorApplicantName | null;
  status?: TCreatorApplicationStatus | null;
  submittedAt?: string | null;
  decidedAt?: string | null;
  decisionNotes?: string | null;
  profile: TCreatorApplicationProfile;
  updatedAt: string;
};

export type TCreatorApplicationExistingUser = {
  userId: string;
  email: string;
  roles: TUserRole[];
  hasOrganization: boolean;
  organizationId?: string | null;
};

// Shape returned by GET /admin/content-creator-applications/:id (detail).
export type TCreatorApplicationDetail = {
  _id: string;
  applicantType: TCreatorApplicantType;
  applicantUserId?: string | null;
  applicantEmail: string;
  applicantName: TCreatorApplicantName;
  emailVerifiedAt?: string | null;
  status?: TCreatorApplicationStatus | null;
  submittedAt?: string | null;
  decidedAt?: string | null;
  decidedByUserId?: string | null;
  decisionNotes?: string | null;
  profile: TCreatorApplicationProfile;
  createdAt: string;
  updatedAt: string;
  existingUser?: TCreatorApplicationExistingUser | null;
  history: TCreatorApplicationSummary[];
};
